import { useCallback } from 'react';
import {
  useQuery,
  useSuspenseQuery,
  QueryResult,
  useLazyQuery,
  useApolloClient,
  QueryOptions,
  QueryHookOptions,
  SuspenseQueryHookOptions,
  LazyQueryHookOptions,
  LazyQueryExecFunction
} from '@apollo/client';
import { useSnackbarHelper } from '../../useSnackbarHelper';
import QUERY from '../operations/MarketplacePostsNoRevenue.graphql';
import { Query, QuerymarketplacePostsNoRevenueArgs } from '../../__generated__/globalTypes';

export const useMarketplacePostsNoRevenueQuery = (
  options?: QueryHookOptions<Query, QuerymarketplacePostsNoRevenueArgs>
) => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const result = useQuery<Query, QuerymarketplacePostsNoRevenueArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return result;
};

export const useMarketplacePostsNoRevenueLazyQuery = (
  options?: LazyQueryHookOptions<Query, QuerymarketplacePostsNoRevenueArgs>
): QueryResult<Query, QuerymarketplacePostsNoRevenueArgs> & {
  getMarketplacePostsNoRevenue: LazyQueryExecFunction<Query, QuerymarketplacePostsNoRevenueArgs>;
} => {
  const { t, enqueueSnackbar } = useSnackbarHelper();
  const [getMarketplacePostsNoRevenue, result] = useLazyQuery<Query, QuerymarketplacePostsNoRevenueArgs>(QUERY, {
    onError: (error) => {
      enqueueSnackbar(t(error.message), { variant: 'error' });
    },
    ...options
  });

  return { getMarketplacePostsNoRevenue, ...result };
};

export const useMarketplacePostsNoRevenuePromiseQuery = () => {
  const client = useApolloClient();

  const getMarketplacePostsNoRevenue = useCallback(
    (options?: Omit<QueryOptions<QuerymarketplacePostsNoRevenueArgs, Query>, 'query'>) =>
      client.query<Query, QuerymarketplacePostsNoRevenueArgs>({ ...options, query: QUERY }),
    [client]
  );

  return { getMarketplacePostsNoRevenue };
};
// Suspense Query Hooks
export const useMarketplacePostsNoRevenueSuspenseQuery = (
  options?: SuspenseQueryHookOptions<Query, QuerymarketplacePostsNoRevenueArgs>
) => {
  const result = useSuspenseQuery<Query, QuerymarketplacePostsNoRevenueArgs>(QUERY, {
    ...options
  });

  return result;
};
